"use strict";
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.rootHomeSagas = void 0;
var GlobalAction_1 = require("@/pages/common/actions/GlobalAction");
var RootPublicPageSaga_1 = require("@/pages/common/sagas/RootPublicPageSaga");
var effects_1 = require("redux-saga/effects");
var HomeAction_1 = require("@/pages/home/actions/HomeAction");
var UserPropertiesCrud_1 = require("@/pages/saveproperties/sagas/UserPropertiesCrud");
var EnquireAction_1 = require("@/pages/common/actions/EnquireAction");
var stateFilter_1 = require("@/pages/common/sagas/stateFilter");
var ResultItemSaga_1 = require("@/pages/search/sagas/ResultItemSaga");
var SfilterTypeGroup_1 = require("@/pages/common/states/sfilter/sections/SfilterTypeGroup");
var propertyToUrl_1 = require("@/transformers/propertyToUrl");
var WindowApi_1 = require("@/api/browser/WindowApi");
var MobilePromoSaga_1 = require("@/pages/common/sagas/MobilePromoSaga");
var FgpPopSagas_1 = require("@/pages/common/sagas/FgpPopSagas");
var homerem_1 = require("@/pages/home/api/homerem");
var MegaMenuSearchAction_1 = require("@/pages/common/actions/MegaMenuSearchAction");
var format_1 = require("@/utils/format");
var getKeywordSuggestions_1 = require("@/pages/search/sagas/api/getKeywordSuggestions");
var groupRows_1 = require("@/pages/common/transformers/groupRows");
var LayoutState_1 = require("@/pages/common/states/LayoutState");
var getPartBy_1 = require("@/pages/common/transformers/getPartBy");
var LayoutAction_1 = require("@/pages/common/actions/LayoutAction");
var BigPopupState_1 = require("@/pages/common/states/BigPopupState");
var MyPropertyAction_1 = require("@/pages/myproperty/actions/MyPropertyAction");
var getKeyword = function (state) { return state.home.searchInputText; };
var getSfilterType = function (state) { return state.layout.megamenusearch.type; };
var getHomeTranslate = function (state) { return state.home.t; };
var getSearchPopupType = function (state) { return state.layout.megamenusearch.type; };
var getCurrentItem = function (state) { return (state.home.searchSuggestionGroupIndex > -1 && state.home.searchSuggestionRowIndex > -1) ? state.home.searchSuggestionGroups[state.home.searchSuggestionGroupIndex].suggestions[state.home.searchSuggestionRowIndex] : null; };
var getTestimonialScrollIndex = function (state) { return state.home.currentTestimonialIndex; };
var getCurrentGroupIndex = function (state) { return state.home.searchSuggestionGroupIndex; };
var getCurrentRowIndex = function (state) { return state.home.searchSuggestionRowIndex; };
var getSuggestionGroups = function (state) { return state.home.searchSuggestionGroups; };
var watchItemClicked = function () {
    var payload, item, lang, filterType, url;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_ITEM_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 2:
                lang = _a.sent();
                return [4 /*yield*/, effects_1.select(ResultItemSaga_1.getFilterType)];
            case 3:
                filterType = _a.sent();
                return [4 /*yield*/, effects_1.call(propertyToUrl_1.propertyToUrl, lang, item.building, item.referenceId, SfilterTypeGroup_1.ListingPurposeType.toSfilterType(filterType))];
            case 4:
                url = _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchItemEnquireClicked = function () {
    var payload, item;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_ENQUIRE_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                item = payload;
                return [4 /*yield*/, effects_1.put(EnquireAction_1.default.onEnquireClick(item))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchItemFavClicked = function () {
    var payload, item, isSaved, isDeleted;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 12];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_FAV_CLICKED)];
            case 1:
                payload = (_a.sent()).payload;
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(null))];
            case 2:
                _a.sent();
                item = payload;
                if (!!item.isSaved) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.put(LayoutAction_1.default.setLastSavedProperty(item))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.addSavedProperties, [item])];
            case 4:
                isSaved = _a.sent();
                if (!isSaved) return [3 /*break*/, 7];
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setIsSaved(Number(item.referenceId), true))];
            case 5:
                _a.sent();
                return [4 /*yield*/, effects_1.put(GlobalAction_1.default.setBigPopupLocalized('save_property_success', BigPopupState_1.BigPopupType.SUCCESS, 'success', 'sucessSaveProperty'))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7: return [3 /*break*/, 11];
            case 8: return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.deleteSavedProperties, [Number(item.referenceId)])];
            case 9:
                isDeleted = _a.sent();
                if (!isDeleted) return [3 /*break*/, 11];
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setIsSaved(Number(item.referenceId), false))];
            case 10:
                _a.sent();
                _a.label = 11;
            case 11: return [3 /*break*/, 0];
            case 12: return [2 /*return*/];
        }
    });
};
var initIsSaved = function () {
    var savedPropertyIds;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.call(UserPropertiesCrud_1.getSavedPropertyIds)];
            case 1:
                savedPropertyIds = _a.sent();
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setIsSavedRange(savedPropertyIds, true))];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchInitSliders = function () {
    var index;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(getTestimonialScrollIndex)];
            case 1:
                index = _a.sent();
                return [4 /*yield*/, effects_1.fork(homerem_1.initFeatureSlider)];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(homerem_1.initTestimonialSlider, index)];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(homerem_1.initArticlesSlider)];
            case 4:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchInitSearchRentType = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([HomeAction_1.default.ON_HOME_SEARCH_RENT_CLICK])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.onSearchTypeClicked(SfilterTypeGroup_1.SfilterType.RENT))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchInitSearchSaleType = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take([HomeAction_1.default.ON_HOME_SEARCH_SALE_CLICK])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.onSearchTypeClicked(SfilterTypeGroup_1.SfilterType.BUY))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSearchActionClick = function () {
    var keywordInput;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 5];
                return [4 /*yield*/, effects_1.take([HomeAction_1.default.ON_HOME_SEARCH_ACTION_CLICK])];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 2:
                keywordInput = _a.sent();
                if (!keywordInput.length) return [3 /*break*/, 4];
                return [4 /*yield*/, effects_1.call(doSearch, null)];
            case 3:
                _a.sent();
                _a.label = 4;
            case 4: return [3 /*break*/, 0];
            case 5: return [2 /*return*/];
        }
    });
};
var delaySuggestion = function (force) {
    var keywordInput, type, keyword, isChinese, minAutocompleteLength, suggestions, homeTranslate, newSuggestionGroups;
    if (force === void 0) { force = false; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!!force) return [3 /*break*/, 2];
                return [4 /*yield*/, effects_1.delay(800)];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, effects_1.put(HomeAction_1.default.setSuggestionGroups([]))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 4:
                keywordInput = _a.sent();
                return [4 /*yield*/, effects_1.select(getSfilterType)];
            case 5:
                type = _a.sent();
                keyword = format_1.default.normalize(keywordInput.trim());
                return [4 /*yield*/, effects_1.call(WindowApi_1.checkIsChinese, keyword)];
            case 6:
                isChinese = _a.sent();
                minAutocompleteLength = isChinese ? 1 : 3;
                if (keyword.length < minAutocompleteLength)
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setLoading(true))];
            case 7:
                _a.sent();
                return [4 /*yield*/, effects_1.call(getKeywordSuggestions_1.getKeywordSuggestionsByType, keyword, type)];
            case 8:
                suggestions = _a.sent();
                return [4 /*yield*/, effects_1.select(getHomeTranslate)];
            case 9:
                homeTranslate = _a.sent();
                return [4 /*yield*/, effects_1.call(groupRows_1.groupRows, suggestions, homeTranslate)];
            case 10:
                newSuggestionGroups = _a.sent();
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setLoading(false))];
            case 11:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setSuggestionGroups(newSuggestionGroups))];
            case 12:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchSearchSuggestion = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.takeLatest(HomeAction_1.default.ON_HOME_SEARCH_INPUT_TEXT_CHANGED, function () {
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, effects_1.call(delaySuggestion)];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                })];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var doSearch = function (currentItem) {
    var lang, isChinese, rawKeyword, keyword, langCode, searchFilterType, searchResultType, searchResultId, url;
    if (currentItem === void 0) { currentItem = null; }
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguage)];
            case 1:
                lang = _a.sent();
                isChinese = lang === LayoutState_1.Language.EN_US ? false : true;
                return [4 /*yield*/, effects_1.select(getKeyword)];
            case 2:
                rawKeyword = _a.sent();
                keyword = getPartBy_1.getPartBy(isChinese, rawKeyword.split(' | '));
                return [4 /*yield*/, effects_1.select(stateFilter_1.getCurrentLanguageCode)];
            case 3:
                langCode = _a.sent();
                return [4 /*yield*/, effects_1.select(getSearchPopupType)];
            case 4:
                searchFilterType = _a.sent();
                searchResultType = currentItem ? currentItem.type : null;
                searchResultId = currentItem ? currentItem.id : null;
                if (!keyword || !keyword.trim())
                    return [2 /*return*/];
                return [4 /*yield*/, effects_1.call(WindowApi_1.getSearchUrlFromKeywordAndSearchResultType, keyword, searchFilterType, searchResultType, searchResultId, langCode)];
            case 5:
                url = _a.sent();
                return [4 /*yield*/, effects_1.put(MegaMenuSearchAction_1.default.setFullscreenLoading(true))];
            case 6:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.setUrl, url)];
            case 7:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchOnSearchEnter = function () {
    var currentItem;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 8];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_HOME_KEYWORD_ENTER)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestionsActive(false))];
            case 2:
                _a.sent();
                return [4 /*yield*/, effects_1.put(MyPropertyAction_1.default.setSuggestions([]))];
            case 3:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentItem)];
            case 4:
                currentItem = _a.sent();
                if (!currentItem) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setSearchInputText(currentItem.name))];
            case 5:
                _a.sent();
                _a.label = 6;
            case 6:
                ;
                return [4 /*yield*/, effects_1.call(doSearch, currentItem)];
            case 7:
                _a.sent();
                return [3 /*break*/, 0];
            case 8: return [2 /*return*/];
        }
    });
};
var watchOnSearchMouseOver = function () {
    var payload, groupIndex, rowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_HOME_ON_SUGGESTION_FOCUS)];
            case 1:
                payload = (_a.sent()).payload;
                groupIndex = payload.groupIndex, rowIndex = payload.rowIndex;
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setSuggestionGroupRowIndex(groupIndex, rowIndex))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSearchClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_HOME_SUGGESTION_CLICK)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.onKeywordEnter())];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchHomeTestimonialClick = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_HOME_TESTIMONIAL_CLICKED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setTestimonialAutoplay(true))];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
};
var watchOnSearchKeywordUp = function () {
    var groupIndex, rowIndex, suggestionGroups, nextGroupIndex, nextRowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_HOME_KEYWORD_PREV)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentGroupIndex)];
            case 2:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentRowIndex)];
            case 3:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestionGroups)];
            case 4:
                suggestionGroups = _a.sent();
                nextGroupIndex = groupIndex > -1 ? (rowIndex <= 0 ? (groupIndex <= 0 ? suggestionGroups.length - 1 : groupIndex - 1) : groupIndex) : 0;
                nextRowIndex = rowIndex > -1 ? (rowIndex <= 0 ? suggestionGroups[nextGroupIndex].suggestions.length - 1 : rowIndex - 1) : 0;
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setSuggestionGroupRowIndex(nextGroupIndex, nextRowIndex))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchOnSearchKeywordDown = function () {
    var groupIndex, rowIndex, suggestionGroups, nextGroupIndex, nextRowIndex;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 6];
                return [4 /*yield*/, effects_1.take(HomeAction_1.default.ON_HOME_KEYWORD_NEXT)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentGroupIndex)];
            case 2:
                groupIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getCurrentRowIndex)];
            case 3:
                rowIndex = _a.sent();
                return [4 /*yield*/, effects_1.select(getSuggestionGroups)];
            case 4:
                suggestionGroups = _a.sent();
                nextGroupIndex = groupIndex > -1 ? (rowIndex === suggestionGroups[groupIndex].suggestions.length - 1 ? (groupIndex === suggestionGroups.length - 1 ? 0 : groupIndex + 1) : groupIndex) : 0;
                nextRowIndex = rowIndex > -1 ? (rowIndex === suggestionGroups[groupIndex].suggestions.length - 1 ? 0 : rowIndex + 1) : 0;
                return [4 /*yield*/, effects_1.put(HomeAction_1.default.setSuggestionGroupRowIndex(nextGroupIndex, nextRowIndex))];
            case 5:
                _a.sent();
                return [3 /*break*/, 0];
            case 6: return [2 /*return*/];
        }
    });
};
var watchInit = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_DOM_LOADED)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.fork(initIsSaved)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var watchInitTestimonialYoutube = function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, effects_1.take(GlobalAction_1.default.ON_WINDOW_SCROLL)];
            case 1:
                _a.sent();
                return [4 /*yield*/, effects_1.call(WindowApi_1.lazyLoadManualImages)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
};
var rootHomeSagas = {
    rootPublicPageSagas: RootPublicPageSaga_1.rootPublicPageSagas,
    mobilePromoSagas: MobilePromoSaga_1.mobilePromoSagas,
    fgpPopSagas: FgpPopSagas_1.fgpPopSagas,
    watchItemFavClicked: watchItemFavClicked,
    watchItemEnquireClicked: watchItemEnquireClicked,
    watchItemClicked: watchItemClicked,
    watchInitSliders: watchInitSliders,
    watchInitSearchRentType: watchInitSearchRentType,
    watchInitSearchSaleType: watchInitSearchSaleType,
    watchSearchSuggestion: watchSearchSuggestion,
    watchOnSearchMouseOver: watchOnSearchMouseOver,
    watchOnSearchEnter: watchOnSearchEnter,
    watchOnSearchClick: watchOnSearchClick,
    watchHomeTestimonialClick: watchHomeTestimonialClick,
    watchOnSearchActionClick: watchOnSearchActionClick,
    watchOnSearchKeywordUp: watchOnSearchKeywordUp,
    watchOnSearchKeywordDown: watchOnSearchKeywordDown,
    watchInit: watchInit,
    watchInitTestimonialYoutube: watchInitTestimonialYoutube,
};
exports.rootHomeSagas = rootHomeSagas;
